<script setup>
//import moment  from "moment";
import MediaExList from "@/components/media/MediaExList.vue"
import axios  from "axios";
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
    <v-card
		flat
		width="100%"
	>
        <v-toolbar>
			<v-toolbar-title>
            {{ title }}
			</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <v-row>
                <v-col>
					<v-card min-height="500px">
						<v-toolbar>
							<v-spacer />
							<v-btn @click="open_media">
								メディアリストを変更する
							</v-btn>
						</v-toolbar>
						<v-card-text>
							<v-list>
            <v-list-item v-for="item,index in dsplist" :key="index">
                <v-list-item-icon>
                    <v-icon v-if="item.contact_cd==1">
                        mdi-email-outline
                    </v-icon>
                    <v-icon v-else-if="item.contact_cd==2">
                        mdi-application-outline
                    </v-icon>
                    <img src="rel_image/zip.svg" v-else-if="item.contact_cd==5">
                    <img src="rel_image/fax.svg" v-else-if="item.contact_cd==3">
                </v-list-item-icon>
                <v-list-item-content>
                    <v-row>
                        <v-col cols="2">
                            {{item.site_name}}
                        </v-col>
                        <v-col cols="3">
                            {{item.addressee}}
                        </v-col>
                        <v-col>
                        {{ item.contact_item }}
                        </v-col>
                    </v-row>
                </v-list-item-content>
            </v-list-item>

							</v-list>
						</v-card-text>
					</v-card>
                </v-col>
                <v-col>
					<v-card outlined min-height="500px">
					</v-card>
                </v-col>
            </v-row>
        </v-card-text>
<MediaExList ref="me" v-on:select="selected_list($event)" />
    </v-card>
</template>
<script>
export default {
  props : ["list_id","selected_id",],
  head: {
    title() {
      return {
        inner: 'リリース送信管理',
        separator: '|',
        complement: 'PR効果測定 Qlipper',
      }
    },
      link:
        [
          { rel: 'stylesheet', href: "https://qlipper.jp/css/common_vuetify.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/vuetify_custom.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/relcreate.css" },
          { rel: 'stylesheet', href: "./css/relmng.css" },
          { rel: 'stylesheet', href: "https://cdn.jsdelivr.net/npm/@mdi/font@7.3.67/css/materialdesignicons.min.css" },
        ],
  },
	data : function(){
		return {
			dsplist : [],
			slist_id : "",
		};
	},
    computed : {
        doc_id : function() {
            return this.$store.getters['doc_info/get_doc_id'];
        },
        title : function() {
            return this.$store.getters['doc_info/get_title'];
        },
        sub_title : function() {
            return this.$store.getters['doc_info/get_subtitle'];
        },
        summary : function() {
            return this.$store.getters['doc_info/get_summary'];
        },
        doc_signature : function(){
            return this.$store.getters['doc_info/get_signature'];
        },
        direction : function(){
            return this.$store.getters['doc_info/get_direction'];
        },
        e_doc : function() {
            return this.$store.getters['doc_info/get_doc'];
        },
    },
    methods : {
        open_media : function(){
            //this.selected_id=id;
            this.$refs.me.open(2);
        },
        selected_list : function(data){
			this.slist_id = data.id;
			this.get_media_list();
        },
        get_doc : async function(){
            // state の初期化
            this.$store.commit("doc_info/reset");
            let params = new URLSearchParams();
            params.append('id', this.selected_id);

             await axios.post("/api/release/get_userdoc",params)
            .then(response => {
                if(response.data["list"].length > 0)
                {
                    let signature = response.data['list'][0].signature;
                    if(response.data['list'][0].company_name != "" && response.data['list'][0].company_name != null)
                    {
                        signature = response.data['list'][0].company_name + "\n" + response.data['list'][0].signature;
                    }
                    this.$store.commit("doc_info/set_val",{
                        "doc_id"        : response.data['list'][0].id,
                        "title"         : response.data['list'][0].title,
                        "sub_title"     : response.data['list'][0].sub_title,
                        "summary"       : response.data['list'][0].summary,
                        "doc"           : response.data['list'][0].doc,
                        "direction"     : response.data['list'][0].direction,
                        "signature"     : signature,
                        "conf_id"       : response.data['list'][0].conf_id,
                        "schedule_id"   : response.data['list'][0].schedule_id,
                        "release_date"  : response.data['list'][0].release_date,
                        "product_id"    : response.data['list'][0].product_id,
                        "therm"         : response.data['list'][0].therm,
                        "docstatus"     : response.data['list'][0].status,
                        "uuid"          : response.data['list'][0].uuid,
                        "temp_id"       : response.data['list'][0].temp_id,
                        "share_flg"     : response.data['list'][0].share_flg,
                    });
                    if(response.data['list'][0].migration == 't')
                    {
                        this.$store.commit("doc_info/set_migration");
                    }
                    this.load_flg=true;
                }
                console.log(this.title);
            }).catch((error) => {
                        window.location.href = 'https://qlipper.jp/login';
                        console.error('失敗です', error);
            });

        },
        get_media_list : async function (){
            this.isLoading = true;
            let params = new URLSearchParams();
            params.append("list_id",this.slist_id);
            await axios.post("/api/media/get_media_list",params)
            .then(response => {
                this.dsplist = response.data;
                this.isLoading = false;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
    },
    created : function(){
		this.slist_id = this.list_id;
        this.get_doc();
		this.get_media_list();
    },
}
</script>
